export const defaultProperties = {
    multiple: 1,
    width: 480,
    height: 480,
    color: "#fcfcfc",
    hingePosition: "none",
    glazing: 'normal',
    horizontalLowerBars: {
        number: 0,
        barWidth: 28
    },
    verticalLowerBars: {
        number: 0,
        barWidth: 28
    },
    horizontalUpperBars: {
        number: 0,
        barWidth: 28
    },
    verticalUpperBars: {
        number: 0,
        barWidth: 28
    },
    hardening: "none",
    slotVentilator: "none",
    windowback: "none"
};

export const defaultFont = 'Bitstream Vera Sans, Helvetica, sans-serif';
export const defaultGlazingFill = "#f5f8fa";
export const defaultDownScale = 100 / 480;
export const animationDuration = 200;
export const animationEasing = "bezier(0.175, 0.885, 0.32, 1.275)";

export const visualizerDidUpdateEvent = new Event('fpc-visualizerDidUpdate')